import React from 'react';

const SelectForm = (props)=>{
    return (
        <select 
            name={props.id}
            id={props.id}
            className={"form-control"+props.class}
            disabled={props.disabled}
            value={props.value} 
            onChange={(e)=>props.handleChange(e, props.variables)} 
            required={props.required}
            onKeyPress={(e)=>props.validate(e)}
            style={props.styles}
        >
            <option value="">Seleccione...</option>
            {props.options.map((option, i)=>
                <option key={i} value={option.value}>{option.text}</option>
            )}
        </select>
    )
}

export default SelectForm;

SelectForm.defaultProps = {
    disabled:false,
    required:false,
    class:'',
    type:'text',
    validate:()=>{},
    variables:'',
    styles:{}
}